import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import CKEditorField from "../../../components/cmp/CKEditorField";
import { Alerts, GetEmail } from "../../../helpers";
import { BiCategory } from "react-icons/bi";
import { FaPlus, FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import ThemeModal from "../../../components/cmp/ThemeModal";
import ConfModal from "../../../components/cmp/ConfModal";
const EmailTemplate = () => {
   const [isLoading, setLoading] = useState(true);
   const [templates, setTemplates] = useState([]);
   const [addNew, setAddNew] = useState(false);
   const [isEdit, setEdit] = useState(false);
   const [singleTempalte, setSingleTemplate] = useState(null);

   const handleOpenEdit = (id) => {
      const fTemplate = templates.find(el => el.id === parseInt(id));
      if (fTemplate) {
         setSingleTemplate(fTemplate);
         setEdit(true)
      }
   }
   const handleCloseEdit = () => {
      setSingleTemplate(null);
      setEdit(false)
   }

   const getData = async () => {
      let resp = await GetEmail.getAllEmailTemplate();
      if (resp && resp.status) {
         setTemplates(resp.emailTemplates);
         setLoading(false);
      }
   }

   useEffect(() => {
      getData();
   }, [])



   const options = {
      filter: false,
      download: false,
      print: false,
      selectableRows: false
   };

   const columns = [
      {
         name: 'SL'
      },
      {
         name: 'Name',
         sortable: true,
      },
      {
         name: 'Subject',
         sortable: true,
      },
      {
         name: 'Status',
         sortable: true,
      },
      {
         name: 'Actions',
         sortable: false,
      },
   ];


   const initialValues = {
      name: "",
      subject: "",
      status: "1",
      body: "",
   };

   const validationSchema = Yup.object({
      name: Yup.string().required("Name is required"),
      subject: Yup.string().required("Subject is required"),
      status: Yup.string().required("Status is required"),
      body: Yup.string().required("Body is required"),
   });
   const handleSubmit = async (values) => {
      const resp = await GetEmail.createEmailTemplate(values);
         if(resp && resp.status){
         Alerts.alertMessage(resp.message, 'top-right', 'success');
         getData();
         setAddNew(false)
      }else{
          Alerts.alertMessage('Something went wrong!', 'top-right', 'error');
      }
   };

   const handleDeleteTemplate = (delId) => {
      console.log(delId);
   }


  const handleUpdateTemplate = async (values) => {
      const resp = await GetEmail.updateEmailTemplate(singleTempalte.id, values);
      if(resp && resp.status){
         Alerts.alertMessage(resp.message, 'top-right', 'success');
         getData();
         setEdit(false)
      }else{
          Alerts.alertMessage('Something went wrong!', 'top-right', 'error');
      }
   }

   return (
      <>
         <div className="innerPageWrapper">
            <div className='container-fluid'>
               <div className='page-title'>
                  <h2><BiCategory /> Email Templates</h2>
                  <button type="button" onClick={() => setAddNew(true)} className="btn btn-success"><FaPlus /> Add New</button>
               </div>
               {
                  isLoading ? <div className='loader'>
                     <img src='/images/loader.gif' alt='loader' />
                  </div> : <>
                     <MUIDataTable
                        title="Email Templates"
                        data={templates.map((item, i) => {

                           return [
                              ++i,
                              item.name,
                              item.subject,
                              <div className={`badge ${item.status ? "bg-success" : "bg-danger"}`}>{item.status ? 'Active' : 'Draft'}</div>,
                              <div className={`actions`}>
                                 <button onClick={() => handleOpenEdit(item.id)} className="btn btn-info"><FaEdit size={14} /></button> |
                                 <ConfModal message={'Are you sure you want to delete this template!'} delId={item.id} handleDelete={handleDeleteTemplate} />
                              </div>
                           ]
                        })}
                        columns={columns}
                        options={options}
                     />

                  </>
               }
            </div>
         </div>
         <ThemeModal show={addNew} handleHide={() => setAddNew(false)} title={'Add New Template'} isFullscreen={true}>
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
               {({ errors, touched }) => (
                  <Form>
                     <div className="form-group">
                        <label>Name</label>
                        <Field name="name" className="form-control" />
                        <ErrorMessage name="name" component="div" className="text-danger" />
                     </div>

                     <div className="form-group">
                        <label>Subject</label>
                        <Field name="subject" className="form-control" />
                        <ErrorMessage name="subject" component="div" className="text-danger" />
                     </div>

                     <div className="form-group">
                        <label>Status</label>
                        <Field as="select" name="status" className="form-control">
                           <option value="1">Active</option>
                           <option value="0">Draft</option>
                        </Field>
                        <ErrorMessage name="status" component="div" className="text-danger" />
                     </div>

                     <div className="form-group">
                        <label>Body</label>
                        <Field
                           as="textarea"
                           name="body"
                           className="form-control"
                           rows="6"
                        />
                        <ErrorMessage name="body" component="div" className="text-danger" />
                     </div>

                     <button type="submit" className="btn btn-primary mt-3">
                        Submit
                     </button>
                  </Form>
               )}
            </Formik>

         </ThemeModal>
          {
            singleTempalte &&   <ThemeModal show={isEdit} handleHide={handleCloseEdit} title={'Update Email Template'} isFullscreen={true}>
            <Formik
               enableReinitialize={true}
               initialValues={{
                  name: singleTempalte.name,
                  subject: singleTempalte.subject,
                  status: singleTempalte.status,
                  body: singleTempalte.body,
               }}

               validationSchema={validationSchema}
               onSubmit={handleUpdateTemplate}>
               {({ errors, touched }) => (
                  <Form>
                     <div className="form-group">
                        <label>Name</label>
                        <Field name="name" className="form-control" />
                        <ErrorMessage name="name" component="div" className="text-danger" />
                     </div>

                     <div className="form-group">
                        <label>Subject</label>
                        <Field name="subject" className="form-control" />
                        <ErrorMessage name="subject" component="div" className="text-danger" />
                     </div>

                     <div className="form-group">
                        <label>Status</label>
                        <Field as="select" name="status" className="form-control">
                           <option value="1">Active</option>
                           <option value="0">Draft</option>
                        </Field>
                        <ErrorMessage name="status" component="div" className="text-danger" />
                     </div>

                     <div className="form-group">
                        <label>Body</label>
                        <Field
                           as="textarea"
                           name="body"
                           className="form-control"
                           rows="6"
                        />
                        <ErrorMessage name="body" component="div" className="text-danger" />
                     </div>

                     <button type="submit" className="btn btn-primary mt-3">
                        Submit
                     </button>
                  </Form>
               )}
            </Formik>

         </ThemeModal>
          }
       
      </>

   )
}
export default EmailTemplate;